import { useEffect, useState } from 'react'
import classNames from 'classnames'
import { bool, number, oneOfType, string } from 'prop-types'
import { BetaBadge } from '@winnin/winnin_ui.components.beta-badge'
import { Icon } from '@winnin/winnin_ui.components.icon'

import { ProviderIcon } from 'components/provider-icon'
import './index.scss'

const PROVIDERS = {
  youtube: 'yt',
  facebook: 'fb',
  instagram: 'in',
  tiktok: 'tt',
  twitch: 'tw',
}

function ThumbnailImage({ src, isFallbackText, fail, href, width, height, setFail, alt }) {
  if (!src || src === '' || fail) {
    if (isFallbackText) {
      return <p className="text-fallback">No image</p>
    }

    return <Icon className="thumbnail-no-image" icon="noImage" />
  }

  if (href && src)
    return (
      <a href={href}>
        <img src={src} loading="lazy" width={width} height={height} alt={alt} />
      </a>
    )

  if (src)
    return (
      <img
        src={src}
        loading="lazy"
        width={width}
        height={height}
        onError={() => {
          setFail(true)
        }}
        alt={alt}
      />
    )
}

const Thumbnail = ({
  className,
  provider,
  trending,
  src,
  alt,
  href,
  width,
  height,
  isFallbackText,
  showBetaBadge = false,
  ...props
}) => {
  const containerClass = classNames('thumbnail-component-container', className)
  const [fail, setFail] = useState(false)

  useEffect(() => {
    setFail(false)
  }, [src])

  const providerIcon = PROVIDERS[provider] ?? null

  return (
    <div className={containerClass} {...props}>
      <ThumbnailImage
        alt={alt}
        fail={fail}
        height={height}
        href={href}
        isFallbackText={isFallbackText}
        setFail={setFail}
        src={src}
        width={width}
      />
      {provider && (
        <div className="provider">
          {provider === 'tiktok' && showBetaBadge ? (
            <BetaBadge>
              <RenderProviderIcon providerIcon={providerIcon} />
            </BetaBadge>
          ) : (
            <RenderProviderIcon providerIcon={providerIcon} />
          )}
        </div>
      )}
      {trending && (
        <div
          className="tooltipped tooltipped-n tooltipped-multiline trend"
          aria-label="Creators with the fastest growing subscriber base for each tier and provider over the last month"
        >
          <Icon icon="trending" className="icon" />
        </div>
      )}
    </div>
  )
}

Thumbnail.propTypes = {
  className: string,
  provider: string,
  trending: bool,
  src: string,
  alt: string.isRequired,
  href: string,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  isFallbackText: bool,
}

Thumbnail.defaultProps = {
  alt: 'No alt text',
  width: null,
  height: null,
  isFallbackText: false,
}

export default Thumbnail

function RenderProviderIcon({ providerIcon }) {
  return (
    <ProviderIcon
      icon={providerIcon}
      className="provider-thumbnail-component-item"
      width={providerIcon === 'yt' ? 29 : 24}
    />
  )
}
